import httpService from '@Utils/httpService';

const baseUrl = 'api/Management/Companies';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  updateOwner(id,userId) {
    return httpService.put({
      url: `${baseUrl}/${id}/owner`,
      data:{userId},
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  
  suspend(id, status) {
    return httpService.put({
      url: `${baseUrl}/${id}/suspend/${status}`,
    });
  },
  delete(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  getUsers(companyId) {
    return httpService.get({
      url: `${baseUrl}/${companyId}/users`,
    });
  },
  getFacilities(companyId) {
    return httpService.get({
      url: `${baseUrl}/${companyId}/facilities`,
    });
  },
 
   getStorage(companyId) {
    return httpService.get({
      url: `${baseUrl}/${companyId}/storage`,
    });
  },
  updateStorage(companyId,data) {
    return httpService.put({
      url: `${baseUrl}/${companyId}/storage`,
      data
    });
  },
  validateStorage(companyId,data) {
    return httpService.post({
      url: `${baseUrl}/${companyId}/validate-storage`,
      data
    });
  },
  resendInvitation(companyId){
    return httpService.post({
      url: `${baseUrl}/resendInvitation/${companyId}`,
    });
  },
  impersonate(companyId){
    return httpService.post({
      url: `${baseUrl}/impersonate`,
      data:{companyId}
    });
  },
  exitImpersonation(){
    return httpService.post({
      url: `${baseUrl}/exit-impersonation`,
    });
  },
  forceLogout(companyId, userId) {
    return httpService.post({
      url: `${baseUrl}/${companyId}/users/${userId}/force-logout`,
    });
  },
  resetPassword(companyId, userId) {
    return httpService.post({
      url: `${baseUrl}/${companyId}/users/${userId}/reset-password`,
    });
  }
};
